var React = require('react');

function DownloadRoundLarge (props) {
    return React.createElement("svg",props,[React.createElement("g",{"clipPath":"url(#clip0_4388_9046)","key":0},[React.createElement("path",{"d":"M10.75 13.668L16 18.6667L21.25 13.668","strokeWidth":"2","strokeLinecap":"round","strokeLinejoin":"round","key":0}),React.createElement("path",{"d":"M16 5.33398V18.6638","strokeWidth":"2","strokeLinecap":"round","strokeLinejoin":"round","key":1}),React.createElement("path",{"d":"M26 26.666H6","strokeWidth":"2","strokeLinecap":"round","strokeLinejoin":"round","key":2})]),React.createElement("defs",{"key":1},React.createElement("clipPath",null,React.createElement("rect",{"width":"32","height":"32"})))]);
}

DownloadRoundLarge.defaultProps = {"width":"32","height":"32","viewBox":"0 0 32 32","fill":"none"};

module.exports = DownloadRoundLarge;

DownloadRoundLarge.default = DownloadRoundLarge;
